import axios from "axios";

/**
 * Instância axios EXCLUSIVA do portal do colaborador.
 *
 * O `api` de `api.ts` lê `auth.accessToken` (staff) no interceptor. Se o portal
 * o usasse, mandaria o token do staff — ou nenhum — para `/dp/me/*`, e o backend
 * responderia 401 sem que o motivo fosse óbvio na tela. Nenhuma tela de
 * `views/colaborador/` deve importar o `api`.
 *
 * O campo lido é `accessToken`, o mesmo nome que o slice grava (ver o comentário
 * sobre o BUG-006 em `employeeAuthSlice.ts`).
 */
let getEmployeeToken: () => string | null = () => null;

export const setEmployeeTokenGetter = (fn: () => string | null) => {
  getEmployeeToken = fn;
};

export const employeeApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL,
  headers: { "Content-Type": "application/json" },
});

employeeApi.interceptors.request.use((config) => {
  config.headers = config.headers ?? {};

  const hasAuth =
    Boolean((config.headers as any).Authorization) ||
    Boolean((config.headers as any).authorization);

  if (!hasAuth) {
    const token = getEmployeeToken();
    if (token) (config.headers as any).Authorization = `Bearer ${token}`;
  }

  return config;
});
